function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-iot_svg__b{fill:#dbe2e5}.icon-iot_svg__c{fill:#b0bec5}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__b",
  d: "M42.694 114.441v12.966H28.913a6.47 6.47 0 01-6.469-6.469 6.47 6.47 0 016.469-6.469h13.781z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__c",
  d: "M37.969 114.441h4.725v12.966h-4.725z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__b",
  d: "M42.694 93.881v12.966H28.913a6.47 6.47 0 01-6.469-6.469 6.47 6.47 0 016.469-6.469h13.781z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__c",
  d: "M37.969 93.881h4.725v12.966h-4.725z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__b",
  d: "M42.694 73.322v12.966H28.913a6.47 6.47 0 01-6.469-6.469 6.47 6.47 0 016.469-6.467h13.781z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__c",
  d: "M37.969 73.322h4.725v12.966h-4.725z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__b",
  d: "M42.694 52.763v12.966H28.913a6.47 6.47 0 01-6.469-6.469 6.47 6.47 0 016.469-6.469h13.781z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__c",
  d: "M37.969 52.763h4.725v12.966h-4.725z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__b",
  d: "M137.391 65.729V52.763h13.781a6.47 6.47 0 016.469 6.469 6.47 6.47 0 01-6.469 6.471h-13.781z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__c",
  d: "M137.391 52.763h4.725v12.966h-4.725z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__b",
  d: "M137.391 86.288V73.322h13.781a6.47 6.47 0 016.469 6.469 6.47 6.47 0 01-6.469 6.469h-13.781z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__c",
  d: "M137.391 73.322h4.725v12.966h-4.725z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__b",
  d: "M137.391 106.847V93.881h13.781a6.47 6.47 0 016.469 6.469 6.47 6.47 0 01-6.469 6.469h-13.781z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__c",
  d: "M137.391 93.881h4.725v12.966h-4.725z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__b",
  d: "M137.391 127.407v-12.966h13.781a6.47 6.47 0 016.469 6.469 6.47 6.47 0 01-6.469 6.469h-13.781z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__c",
  d: "M137.391 114.441h4.725v12.966h-4.725z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__b",
  d: "M65.672 42.722H52.706V28.941a6.47 6.47 0 016.469-6.469 6.47 6.47 0 016.469 6.469v13.781z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__c",
  d: "M52.706 38.025h12.966v4.725H52.706z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__b",
  d: "M86.232 42.722H73.266V28.941a6.47 6.47 0 016.469-6.469 6.47 6.47 0 016.469 6.469v13.781z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__c",
  d: "M73.266 38.025h12.966v4.725H73.266z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__b",
  d: "M106.819 42.722H93.853V28.941a6.47 6.47 0 016.469-6.469 6.47 6.47 0 016.469 6.469v13.781z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__c",
  d: "M93.853 38.025h12.966v4.725H93.853z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__b",
  d: "M127.379 42.722h-12.966V28.941a6.47 6.47 0 016.469-6.469 6.47 6.47 0 016.469 6.469v13.781z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__c",
  d: "M114.413 38.025h12.966v4.725h-12.966z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__b",
  d: "M114.413 137.447h12.966v13.781a6.47 6.47 0 01-6.469 6.469 6.47 6.47 0 01-6.469-6.469v-13.781z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__c",
  d: "M114.413 137.447h12.966v4.725h-12.966z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__b",
  d: "M93.853 137.447h12.966v13.781a6.47 6.47 0 01-6.469 6.469 6.47 6.47 0 01-6.467-6.469v-13.781z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__c",
  d: "M93.853 137.447h12.966v4.725H93.853z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__b",
  d: "M73.266 137.447h12.966v13.781a6.47 6.47 0 01-6.469 6.469 6.47 6.47 0 01-6.469-6.469v-13.781z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__c",
  d: "M73.266 137.447h12.966v4.725H73.266z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__b",
  d: "M52.706 137.447h12.966v13.781a6.47 6.47 0 01-6.469 6.469 6.47 6.47 0 01-6.469-6.469v-13.781z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__c",
  d: "M52.706 137.447h12.966v4.725H52.706z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M126.956 137.39H53.041a10.461 10.461 0 01-10.46-10.462V53.041a10.461 10.461 0 0110.46-10.46h73.887a10.461 10.461 0 0110.462 10.46v73.887a10.437 10.437 0 01-10.434 10.462z",
  fill: "#a03624"
});

var _ref35 = /*#__PURE__*/React.createElement("circle", {
  className: "icon-iot_svg__c",
  cx: 5.119,
  cy: 5.119,
  r: 5.119,
  transform: "translate(84.881 108.675)"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M111.994 84.29a21.995 21.995 0 10-35.944 16.988 12.716 12.716 0 014.641 9.816v1.378a3.145 3.145 0 003.15 3.15H96.16a3.145 3.145 0 003.15-3.15v-1.379a12.675 12.675 0 014.616-9.787 21.971 21.971 0 008.068-17.016z",
  fill: "#fff"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  className: "icon-iot_svg__c",
  d: "M79.369 109.884a13.741 13.741 0 01.084 1.519v1.547a3.577 3.577 0 003.572 3.572h13.978a3.577 3.577 0 003.572-3.572v-1.547a13.741 13.741 0 01.084-1.519z"
});

var SvgIconIot = function SvgIconIot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37);
};

export default "data:image/svg+xml;base64,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";
export { SvgIconIot as ReactComponent };